// extracted by mini-css-extract-plugin
module.exports = {"sh7xaus":"sh7xaus"};